import React, { useEffect, useRef, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import Meta from '../components/Meta';
import { requireAuth, useAuth } from '../util/auth';
import OrganizationSection from '../components/OrganizationSection/OrganizationSection';
import PersonnelSection from '../components/PersonnelSection/PersonnelSection';
import MethodSection from '../components/MethodSection/MethodSection';
import SampleSection from '../components/SampleSection/SampleSection';
import InstrumentSection from '../components/InstrumentSection/InstrumentSection';
import Section from '../components/Section';
import ParameterSection from '../components/ParameterSection/ParameterSection';
import { useGetPersonnel } from '../util/db';
import { RULES, SCREEN } from '../util/Constant';
import { checkHasPermission, isAdmin } from '../util/util';

function PersonnelPage() {
  const auth = useAuth();
  const [activeTab, setActiveTab] = useState('personnel');
  const [loading, setLoading] = useState(false);
  const { data: personnel } = useGetPersonnel();
  const [permissionData, setPermissionData] = useState(null);

  useEffect(() => {
    if (
      Array.isArray(personnel) &&
      personnel.length > 0 &&
      auth.user?.email &&
      auth.permissionData
    ) {
      const matchingUser = personnel.find((person) => person.email === auth.user?.email);
      if (matchingUser) {
        setPermissionData(auth.permissionData[matchingUser.permission]);
      }
    }
  }, [personnel, auth.user?.email, auth.permissionData]);

  const handleSelect = (e) => {
    setLoading(true);
    setActiveTab(e);
  };

  const initialTabSet = useRef(false);
  useEffect(() => {
    if (permissionData && !initialTabSet.current) {
      if (
        !checkHasPermission(permissionData?.[SCREEN?.ORGANIZTION], RULES.VIEW) &&
        !isAdmin(permissionData)
      )
        setActiveTab('personnel');
      else {
        setActiveTab('organization');
      }
      initialTabSet.current = true;
    }
  }, [permissionData]);

  function renderBottomSection(section) {
    switch (section) {
      case 'personnel':
        return <PersonnelSection />;
      case 'method':
        return <MethodSection />;
      case 'sample':
        return <SampleSection />;
      case 'instrument':
        return <InstrumentSection />;
      case 'parameter':
        return <ParameterSection />;
      default:
        return <OrganizationSection />;
    }
  }

  return (
    <>
      <Meta title="Master Data" />
      <Tabs
        activeKey={activeTab}
        id="uncontrolled-tab-example"
        className="tri-tabs"
        onSelect={handleSelect}
      >
        {isAdmin(permissionData) ||
        checkHasPermission(permissionData?.[SCREEN?.ORGANIZTION], RULES.VIEW) ? (
          <Tab eventKey="organization" title="Organization" />
        ) : (
          <></>
        )}
        <Tab eventKey="personnel" title="Personnel" />
        {isAdmin(permissionData) ||
        checkHasPermission(permissionData?.[SCREEN?.METHOD], RULES.VIEW) ? (
          <Tab eventKey="method" title="Test Methods" />
        ) : (
          <></>
        )}
        {isAdmin(permissionData) ||
        checkHasPermission(permissionData?.[SCREEN?.SAMPLE], RULES.VIEW) ? (
          <Tab eventKey="sample" title="QC Samples" />
        ) : (
          <></>
        )}
        {isAdmin(permissionData) ||
        checkHasPermission(permissionData?.[SCREEN?.INSTRUMENT], RULES.VIEW) ? (
          <Tab eventKey="instrument" title="Instruments" />
        ) : (
          <></>
        )}
        <Tab eventKey="parameter" title="Parameter Ordering" />
      </Tabs>
      <Section bg="white" textColor="dark" size="lg" bgImage="" bgImageOpacity={1}>
        <div>{renderBottomSection(activeTab)}</div>
      </Section>
    </>
  );
}

export default requireAuth(PersonnelPage);
